module.exports = __webpack_public_path__ + "img/zhou3.e1406a20.png";